import type { Ref } from "vue";

export interface ISubmitFormWithRetryOptions {
  formRef: Ref<HTMLFormElement | null>;
  maxRetries?: number;
  retryDelayMs?: number;
  onRetrySuccess?: (attempt: number) => void;
}

// Retries submitting a form whose ref may not be populated yet (e.g. right after a v-if toggles it into the DOM).
export const submitFormWithRetry = async ({
  formRef,
  maxRetries = 3,
  retryDelayMs = 100,
  onRetrySuccess,
}: ISubmitFormWithRetryOptions): Promise<boolean> => {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    if (formRef.value) {
      formRef.value.submit();
      if (attempt > 1) {
        onRetrySuccess?.(attempt);
      }
      return true;
    }
    if (attempt < maxRetries) {
      await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
    }
  }
  return false;
};
